/*
 * @author  Agence Dn'D <contact@dnd.fr>
 * @license https://opensource.org/licenses/osl-3.0.php  Open Software License (OSL 3.0)
 * @link    https://www.dnd.fr/
 */

document.querySelectorAll('.lolyshop-comparison-tabs').forEach((root) => {
    const buttons = root.querySelectorAll('.lolyshop-comparison-tabs__button');
    const panels = root.querySelectorAll('.lolyshop-comparison-tabs__panel');
    const images = root.querySelectorAll('.lolyshop-comparison-tabs__image');

    const selectTab = (blockId) => {
        const syncState = (element) => element.classList.toggle('is-active', element.dataset.blockId === blockId);

        buttons.forEach(syncState);
        panels.forEach(syncState);
        images.forEach(syncState);
    };

    buttons.forEach((button) => {
        button.addEventListener('click', () => selectTab(button.dataset.blockId));
    });
});
